import React from "react";

import { forms } from "src/modules/kd/forms";
import { FormExplorer as FormExplorerBare } from "src/modules/shared/form-explorer";

export const FormExplorer: React.FunctionComponent = () => {
	return <FormExplorerBare forms={forms} />;
};
